"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { Check } from "iconoir-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "border-grey-500 data-checked:border-grey-950 data-checked:bg-grey-950 data-indeterminate:border-grey-950 data-indeterminate:bg-grey-950 data-checked:text-grey-0 data-indeterminate:text-grey-0 focus-visible:ring-pulse-400 rounded-ds-s bg-grey-0 grid h-4 w-4 shrink-0 place-content-center border transition-colors focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        "grid place-content-center text-current data-unchecked:hidden"
      )}
    >
      <Check className="h-3 w-3" strokeWidth={2.25} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = "Checkbox";

export { Checkbox };
